import React from 'react';
import { Space, Typography } from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  HourglassOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import styled from '@emotion/styled';

const Text = styled(Typography.Text)``;
export const InspectionStaticCell = (
  props: Partial<{
    pending: number;
    other: number;
    pass: number;
    fail: number;
  }>
) => {
  return (
    <Space>
      <Space>
        <CheckOutlined style={{ color: 'green' }} />
        <Text>{props.pass || 0}</Text>
      </Space>
      <Space>
        <CloseOutlined style={{ color: 'red' }} />
        <Text>{props.fail || 0}</Text>
      </Space>
      <Space>
        <HourglassOutlined style={{ color: 'grey' }} />
        <Text>{props.pending || 0}</Text>
      </Space>
      <Space>
        <MinusCircleOutlined style={{ color: 'grey' }} />
        <Text>{props.other || 0}</Text>
      </Space>
    </Space>
  );
};
